module.exports = __webpack_public_path__ + "img/reserved_selected.7cd71f46.svg";